import { inject, Injectable } from '@angular/core';
import { LinkService } from '@sirius/common';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class CustomCookieService {
    private _linkService = inject(LinkService);
    private _cookieService = inject(CookieService);

    setCookies(): void {
        const utm = this._linkService.getUtmParams();
        if (!utm) {
            return;
        }

        const referrer = utm[0].value;
        const isInternalReferrer = referrer.split('.').includes('universal-robots');

        if (!isInternalReferrer) {
            this._cookieService.set('referer_info', JSON.stringify(utm), {
                sameSite: 'Strict',
                path: '/',
            });
        }
    }
}
